import {ActionBarWrapper} from 'components/wrappers/pages'
import SearchBar from 'components/Fields/ReduxForm/SearchBar'
import styles from './ActionBar.css'
import {reduxForm, Field} from 'redux-form'
import MenuTitle from 'components/MenuTitle'
import {isFullSiteMode} from 'utils/fullSite'

class ActionBar extends React.Component {
  render () {
    const {enableInviteStaff, enableExportStaff} = this.props

    return (
      <div>
        <MenuTitle menuTitle='Staff' />
        <div className='pull-right col-md-6 action-staff'>
          { !isFullSiteMode() &&
            <button className='btn btn-primary'
              onClick={this._onClickExport}
              disabled={!enableExportStaff}
            >
              Export
            </button>
          }
          <button
            className={`btn btn-primary ml-10px ${styles['btn-invite-staff']}`}
            onClick={this._onClickInviteStaff}
            disabled={!enableInviteStaff}
          >
            Invite Staff
          </button>
        </div>
        <ActionBarWrapper>
          <div className={`col-xs-12 ${styles.wrapper} search-staff`}>
            <span className='pull-left'>
              <div className='form-group'>
                <Field
                  name='keyword'
                  component={SearchBar}
                  onChange={this._onChangeKeyword}
                  placeholder='Search'
                />
              </div>
            </span>
          </div>
        </ActionBarWrapper>
      </div>
    )
  }

  _onChangeKeyword = (e, keyword) => {
    this.props.onChangeSearch({trigger: 'keyword', keyword})
  }

  _onClickExport = () => {
    this.props.onClickExport()
  }

  _onClickInviteStaff = () => {
    if (this.props.enableInviteStaff) {
      this.props.onClickInviteStaff()
    }
  }
}

ActionBar.propTypes = {
  onChangeSearch: React.PropTypes.func,
  onClickExport: React.PropTypes.func,
  onClickInviteStaff: React.PropTypes.func,
  enableInviteStaff: React.PropTypes.bool,
  enableExportStaff: React.PropTypes.bool
}

const mapForm = {
  form: 'search'
}

export default reduxForm(mapForm)(ActionBar)



// WEBPACK FOOTER //
// ./app/pages/Employees/Staff/ActionBar/ActionBar.js